import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
const factInit = () => {
  const $factsWrapper = document.querySelectorAll('.frame-type-fact_group');
  if (!$factsWrapper.length) return;
  $factsWrapper.forEach($el => {
    const items = $el.querySelectorAll('.fact-item_num');
    gsap.from(items, {
      textContent: 0,
      duration: 4,
      ease: 'power1',
      snap: {
        textContent: 1
      },
      stagger: {
        onComplete: () => [...items].forEach($item => {
          $item.innerHTML = $item.dataset.num;
        })
      },
      scrollTrigger: {
        trigger: $el,
        toggleActions: 'play pause play pause'
      }
    });
  });
};
export default factInit;